import { createAction, props } from '@ngrx/store';
import { PersonalParticularModel } from '@shared/data-access/models';

// note: [cms] fix(HUT-2117): reference between old & new state
export const getDetail = createAction('[Personal Particular Old] GET DETAIL', props<PersonalParticularModel>());
